// 用户
export default [{ // 用户管理
  path: '/personnelManager',
  name: 'personnelManager',
  component: resolve => require(['@/views/personnel/personnelManager.vue'], resolve),
  meta: {
    group: "/personnelManager",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 新增用户
  path: '/addPersonnel',
  name: 'addPersonnel',
  component: resolve => require(['@/views/personnel/addPersonnel'], resolve),
  meta: {
    group: "/personnelManager",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 编辑用户
  path: '/editPersonnel',
  name: 'editPersonnel',
  component: resolve => require(['@/views/personnel/addPersonnel'], resolve),
  meta: {
    group: "/personnelManager",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}]


// WEBPACK FOOTER //
// ./src/router/personnel/peronnel.js